module.exports = __webpack_public_path__ + "static/media/FFE2355_BY.74c9beee.jpg";